import classNames from 'classnames';
import { List } from 'yoso';
import { Ranking } from '~/components/Challenge/Leaderboard/ChallengeLeaderboard.hooks';
import { ChallengeLeaderboardItem } from '~/components/Challenge/Leaderboard/List/ChallengeLeaderboardItem';
import styles from './ChallengeLeaderboardList.module.scss';

export type ChallengeLeaderboardListProps = {
  className?: string;
  items: Ranking[];
};
export const ChallengeLeaderboardList = ({ className, items }: ChallengeLeaderboardListProps) => (
  <List className={classNames(styles.root, className)}>
    {items.map((item) => (
      <li key={item.rank}>
        <ChallengeLeaderboardItem className={styles.item} {...item} />
      </li>
    ))}
  </List>
);
